import React from "react";
import { Link } from "react-router-dom";
import iconBell from "../../images/icon/bell-icon.svg";

const NewsletterBox: React.FC = () => {
  return (
    <div className="item_details-newslatter xb-border mt-80">
      <div className="xb-item--holder ul_li_between align-items-start">
        <div className="xb-item-heading_info">
          <h3 className="item_details_info_heading">Get growth tips in your inbox</h3>
          <p>
            Short, simple SMM tips for creators and resellers. <br />
            One email. No spam.
          </p>
        </div>

        <Link to="#" className="xb-item--bell-icon xb-border">
          <img src={iconBell} alt="Notification Bell" />
        </Link>
      </div>

      <div className="xb-item--item-input_field pos-rel">
        <input type="email" placeholder="you@example.com" />
        <button type="submit">Subscribe</button>
      </div>
    </div>
  );
};

export default NewsletterBox;
